import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  SetStateAction,
  Dispatch,
} from "react";
import CookieService from "./cookies"; // Cookie service file for managing cookies
import { getItemFromLocalStore } from "../utils";
import { FullRegistrationFormType as User } from "../schemas/FullRegistrationFormSchema";
// import { FullRegistrationFormType as XflowUser } from "../schemas/XFlowFullRegSchema";

import { get_user_details } from "../constants/apis";
import { useFetch } from "../hooks/useFetch";

interface AppContextType {
  jwtToken: string | null;
  adminJWTToken: string | null;
  setJwtToken: (token: string, key?: string) => void;
  removeJwtToken: () => void;
  checkAvailability: boolean;
  setCheckAvailability: Dispatch<SetStateAction<boolean>>;
  user: User | null;
  userLoading: boolean;
  refetchUser: () => void;
  xFlow: boolean;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [jwtToken, setJwtTokenState] = useState<string | null>(
    CookieService.getCookie("jwtToken"),
  );

  const [adminJWTToken, setAdminJWTToken] = useState<string | null>(
    CookieService.getCookie("adminToken"),
  );

  const [checkAvailability, setCheckAvailability] = useState<boolean>(
    getItemFromLocalStore("check_availability") || false,
  );

  const [xFlow, setXFlow] = useState(false);

  const {
    data: user,
    loading: userLoading,
    refetch: refetchUser,
  } = useFetch<User>(
    jwtToken ? get_user_details : null,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    },
    jwtToken!,
  );

  // console.log("user ---", user);

  // // TODO: simple payment -> XFlow
  // useEffect(() => {
  //   if (user) {
  //     setXFlow(user?.user_services?.simple_payment ? true : false);
  //   }
  // }, [user]);

  // Load isCheck Availability cookie on initial load.
  useEffect(() => {
    localStorage.setItem(
      "check_availability",
      JSON.stringify(checkAvailability),
    );
  }, [checkAvailability]);

  // Function to set JWT token and save it in cookies
  const setJwtToken = (token: string, key = "jwtToken") => {
    CookieService.setCookie(key, token, 7); // Store for 7 days
    key === "jwtToken" ? setJwtTokenState(token) : setAdminJWTToken(token);
  };

  // Function to remove JWT token
  const removeJwtToken = () => {
    CookieService.deleteCookie("jwtToken");
    CookieService.deleteCookie("adminToken");
    CookieService.deleteCookie("role");

    setJwtTokenState(null);
  };

  return (
    <AppContext.Provider
      value={{
        xFlow,
        checkAvailability,
        setCheckAvailability,

        jwtToken,
        adminJWTToken,
        setJwtToken,
        removeJwtToken,
        user,
        userLoading,
        refetchUser,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
